import { Reducer } from "redux";

import { ApplicationStatefulModule } from "@multiweb/types/react";
import { NAME } from "./constants";
import { reducer } from "./reducer";
import { saga } from "./saga";
import { IMenuOpenedItemsState } from "./types";

export { REMOVE_LABEL_INFO, SET_LABEL_INFO } from "./constants";
export {
    getFormInstanceBaseLabel,
    getFormInstanceLabel,
    getOpenedFormFormCode,
    getOpenedFormInfo,
    getOpenedFormInstanceId,
    getOpenedFormsIds,
    getOpenedFormsInfo,
    getOrderedOpenedFormsInfo,
    isOpenedItemActive,
} from "./selectors";
export { OpenedFormItemInfo, OpenedProfileInfo } from "./types";

export const openedItemsModule: ApplicationStatefulModule<typeof NAME, Reducer<IMenuOpenedItemsState>> = {
    NAME,
    reducer,
    saga,
};
